export const DATABASE_SERVICE_ENDPOINT = window.env.VUE_APP_DATABASE_SERVICE;

// Resource paths
export const DATABASE_RESOURCE_PATH = '/database';
export const TABLE_RESOURCE_PATH = '/table';
export const RECORD_RESOURCE_PATH = '/record';
export const RECORD_DOWNLOAD_RESOURCE_PATH = '/download';
export const COLUMN_RESOURCE_PATH = '/column';
